/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagLeftIcon24Regular = forwardRef('ArrowDim1DiagLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.5 2.25a.75.75 0 0 1 0 1.5H4.81l15.44 15.44V13.5a.75.75 0 0 1 1.5 0v6.25a2 2 0 0 1-2 2H13.5a.75.75 0 0 1 0-1.5h5.69L3.75 4.81v5.69a.75.75 0 0 1-1.5 0V4.25a2 2 0 0 1 2-2h6.25Z" })));
});
